module.exports = __webpack_public_path__ + "img/7.2.B.ee4493c1.png";